import React from "react";
import { Switch, Route } from "react-router-dom";
import Edit from "./Edit";
import Home from "./Home";
import { EtimProvider } from "../../context/ETIMContext";


export default function ETIMIndex(props) {
  return (
    <EtimProvider>
      <Switch>
        <Route
          exact={true}
          path="/series/etim"
          render={(props) => {
            return <Home {...props} />;
          }}
        />
        <Route
          path="/series/etim/edit/:id/:classEtim"
          render={(props) => {
            return <Edit {...props} />;
          }}
        />
        <Route
          path="/series/etim/edit/:id"
          render={(props) => {
            return <Edit {...props} />;
          }}
        />
      </Switch>
    </EtimProvider>
  );
}
